import React from "react";
import { Button } from "@mui/material";
import { deleteManifestItem } from "../../graphql/mutations";
import { toast } from "react-toastify";
import { generateClient } from "aws-amplify/api";

const client = generateClient();

const DeleteManifestItem = ({ id, setManifestItems }) => {
  const handleDeleteManifestItem = async (manifestId) => {
    try {
      await client.graphql({
        query: deleteManifestItem,
        variables: { input: { id: manifestId } },
      });
      setManifestItems((prevState) => {
        return prevState.filter((item) => item.id !== manifestId);
      });
      toast.success("Manifest item deleted");
    } catch (err) {
      console.log("Error deleting carrier:", err);
    }
  };

  return (
    <div>
      <Button
        onClick={() => handleDeleteManifestItem(id)}
        variant="outlined"
        color="error"
        size="small"
      >
        Delete
      </Button>
    </div>
  );
};

export default DeleteManifestItem;
